import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownDepartmentContext } from "./form-dropdown-department.context";

export interface FormDropdownDepartmentProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownDepartment<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownDepartmentProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newDepartment,
    mappedDepartment,
    isCreating,
    setSidebar,
    setFilter,
    setNewDepartment,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownDepartmentContext();
  
  return (
    <div className="department">
      {newDepartment && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new department</h2>
          <p>
            You are creating a new department. Please, fill the fields to create a
            new department and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="Department Name"
              value={newDepartment.name}
              onChange={(e: any) =>
                setNewDepartment({ ...newDepartment, name: e.target.value })
              }
            />
            <InputText
              placeholder="Department Description"
              value={newDepartment.description}
              onChange={(e: any) =>
                setNewDepartment({ ...newDepartment, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="Department"
        options={ mappedDepartment }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your department"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownDepartment;